<!-- Messages -->
@for (message of messages; track trackByFn($index, message)) {
  <div class="flex group hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5">
    <ng-container>
      <div class="flex flex-auto py-5 pl-6">
        <ng-container *ngTemplateOutlet="messageContent"></ng-container>
      </div>
    </ng-container>
    <!-- Actions -->
    <div class="relative flex flex-col my-5 mr-6 ml-2" *transloco="let t">
    </div>
  </div>
  <!-- Message content template -->
  <ng-template #messageContent>
    <!-- Icon -->
    @if (!message.partaker?.profileImage) {
      <div class="flex shrink-0 items-center justify-center w-8 h-8 mr-4 rounded-full"
        [matTooltip]="$safeNavigationMigration(message.partaker?.displayName)">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:user-circle'">
        </mat-icon>
      </div>
    }
    <!-- Image -->
    @if (message.partaker?.profileImage) {
      <img class="shrink-0 w-10 h-10 mr-4 rounded-full overflow-hidden object-cover object-center"
        [src]="getAvatarUrl(message)" [alt]="'User avatar'" [matTooltip]="message.partaker.displayName">
      }
      <!-- Title, description & time -->
      <div class="flex flex-col flex-auto">
        <div class="flex flex-row flex-auto">
          @if (message.title) {
            <div class="font-semibold line-clamp-1" [innerHTML]="message.title"></div>
          }
          <!-- <ng-container *ngIf="message.partaker?.displayName">
          <div class="font-semibold line-clamp-1 ml-4" [innerHTML]="message.partaker.displayName"></div>
        </ng-container> -->
      </div>
      @if (message.messageText) {
        <div class="line-clamp-2" [innerHTML]="message.messageText"></div>
      }
      <div class="mt-2 text-sm leading-none text-secondary">
        {{message.senderTimestamp | localizeDate:'dd MMM, h:mm a'}}
      </div>
      <ng-container *transloco="let t">
        @if (message.ackTimestamp) {
          <div class="mt-2 text-sm leading-none text-secondary">
            {{ t('ackTime') }}: {{message.ackTimestamp | localizeDate:'dd MMM, h:mm a'}}
          </div>
        }
        @if (message.rcTimestamp) {
          <div class="mt-2 text-sm leading-none text-secondary">
            {{ t('rcTime') }}: {{message.rcTimestamp | localizeDate:'dd MMM, h:mm a'}}
          </div>
        }
      </ng-container>
    </div>
  </ng-template>
}

<!-- No messages -->
@if (!messages || !messages.length) {
  <div class="flex flex-col flex-auto items-center justify-center sm:justify-start py-12 px-8" *transloco="let t">
    <div class="mt-5 text-2xl font-semibold tracking-tight">{{ t('noMessages') }}</div>
    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">{{ t('noMessagesMsg') }}</div>
  </div>
}